import { ritmDate } from '@/utils'

export const formatValue = function(item, val) {
  if (val === null || val === undefined) return val

  const date = ritmDate.date(val)

  switch (item.type) {
    case 'datetime':
    case 'date':
    case 'time':
      return date?.toLocaleString('ru-RU') || date
    case 'number':
    case 'integer':
    case 'numeric':
    case 'float':
    case 'decimal':
      return val?.toLocaleString('ru-RU') || val
    default:
      return val
  }
}
